msgid ""
msgstr ""
"POT-Creation-Date: 2024-02-16 14:52+0100\n"
"MIME-Version: 1.0\n"
"Content-Type: text/plain; charset=UTF-8\n"
"Content-Transfer-Encoding: 8bit\n"
"X-Generator: @lingui/cli\n"
"Language: fi\n"
"Project-Id-Version: 69ffe877770b8fde5aa44a8b4a76deba\n"
"Report-Msgid-Bugs-To: \n"
"Last-Translator: \n"
"Language-Team: Finnish\n"
"Plural-Forms: nplurals=2; plural=(n != 1);\n"
"X-Crowdin-Project: 69ffe877770b8fde5aa44a8b4a76deba\n"
"X-Crowdin-Project-ID: 550\n"
"X-Crowdin-Language: fi\n"
"X-Crowdin-File-ID: 25212\n"

#. js-lingui-explicit-id
#: src/components/Ad/lib/formatDistance.ts:32
#: src/components/Ad/lib/formatDistance.ts:49
msgid "distance.with-unit"
msgstr "{distance} km"

#. js-lingui-explicit-id
#: src/components/Ad/lib/formatDistance.ts:13
msgid "distance.in-meters"
msgstr "{distance} m"

#. Mobility unit, km for finn/dba, scandinavian mile for blocket
#. Mobility unit, km for finn/dba, scandinavian mile for blocket
#. js-lingui-explicit-id
#: src/components/Ad/lib/formatDistance.ts:24
#: src/components/Ad/lib/formatDistance.ts:39
msgid "distance.mobility-unit"
msgstr "{distance} mailia"

#. js-lingui-explicit-id
#: src/islands/search/FiltersModal/filters/RangeFilter.tsx:61
msgid "explore.filter.range.label"
msgstr "{filterName}haarukka"

#. js-lingui-explicit-id
#: src/islands/search/FiltersModal/filters/RangeForm.tsx:82
msgid "filters.range.maximum.label"
msgstr "{filterName}, enintään"

#. js-lingui-explicit-id
#: src/islands/search/FiltersModal/filters/RangeForm.tsx:68
msgid "filters.range.minimum.label"
msgstr "{filterName}, vähintään"

#. js-lingui-explicit-id
#: src/islands/search/FiltersModal.tsx:626
#: src/islands/search/SearchBar.tsx:622
msgid "explore.searchInput.filters.range.both"
msgstr "{min}–{max}"

#. js-lingui-explicit-id
#: src/components/Ad/lib/formatDistance.ts:7
msgid "distance.less-than-100m"
msgstr "100 m tai vähemmän"

#. js-lingui-explicit-id
#: src/components/Ad/AdImageWrapper.tsx:22
msgid "search.ad.recommerce.image-alt"
msgstr "Ilmoituksen kuva"

#. js-lingui-explicit-id
#: src/islands/search/FiltersModal/filters/StandardFilter.tsx:120
msgid "explore.filters.all"
msgstr "Kaikki"

#. js-lingui-explicit-id
#: src/islands/search/FiltersModal.tsx:134
#: src/islands/search/FiltersModal.tsx:141
msgid "explore.searchInput.filters.title"
msgstr "Kaikki suodattimet"

#. js-lingui-explicit-id
#: src/islands/search/FiltersModal.tsx:853
msgid "explore.searchInput.filters.apply"
msgstr "Käytä"

#. js-lingui-explicit-id
#: src/islands/header/Header.tsx:24
#: src/islands/header/Header.tsx:33
#: src/islands/search/StickySearchBar.tsx:76
#: src/islands/search/StickySearchBar.tsx:85
msgid "explore.back.button"
msgstr "Takaisin"

#. js-lingui-explicit-id
#: src/islands/suggestions/Suggestions.tsx:127
msgid "explore.suggestions.title"
msgstr "Hakutulokset"

#. js-lingui-explicit-id
#: src/islands/results/SearchResult.tsx:135
msgid "explore.results.title"
msgstr "Hakutulokset"

#. js-lingui-explicit-id
#: src/islands/header/Header.tsx:54
msgid "explore.header.badge"
msgstr "Beta"

#. js-lingui-explicit-id
#: src/islands/search/FiltersModal.tsx:866
msgid "explore.searchInput.filters.clear.single"
msgstr "Tyhjennä"

#. js-lingui-explicit-id
#: src/islands/search/FiltersModal.tsx:841
msgid "explore.searchInput.filters.clear"
msgstr "Tyhjennä kaikki"

#. js-lingui-explicit-id
#: src/islands/search/SearchBar.tsx:763
#: src/islands/search/SearchBar.tsx:778
msgid "explore.searchInput.clear"
msgstr "Tyhjennä teksti"

#. js-lingui-explicit-id
#: src/islands/search/FiltersModal.tsx:176
#: src/islands/search/FiltersModal.tsx:181
msgid "explore.searchInput.filters.close"
msgstr "Sulje"

#. js-lingui-explicit-id
#: src/islands/results/ErrorState.tsx:52
msgid "explore.results.errorstate.network.heading"
msgstr "Virhe yhteydessä"

#. js-lingui-explicit-id
#: src/islands/suggestions/Suggestions.tsx:74
msgid "explore.suggestions.title.discover.more"
msgstr "Löydä lisää"

#. js-lingui-explicit-id
#: src/islands/header/Header.tsx:48
msgid "explore.header.title"
msgstr "Tutki"

#. js-lingui-explicit-id
#: src/server/server.ts:170
msgid "page.title"
msgstr "Tutki – Tee torilöytöjä tekoälyn avulla"

#. js-lingui-explicit-id
#: src/islands/results/SortingInfo.tsx:58
msgid "explore.sorting.info.body-try-it-two"
msgstr "Tutki analysoi kaiken ilmoitukseen liittyvän tiedon, mukaan lukien kuvat. Torin perinteinen haku löytää osumia ainoastaan teksteihin perustuen."

#. js-lingui-explicit-id
#: src/islands/results/SortingInfo.tsx:55
msgid "explore.sorting.info.title-two"
msgstr "Tutki analysoi tekstin ja kuvat"

#. js-lingui-explicit-id
#: src/islands/results/ErrorState.tsx:26
msgid "explore.results.errorstate.server.message"
msgstr "Tutki ei toimi juuri nyt. Yritä myöhemmin uudelleen."

#. js-lingui-explicit-id
#: src/islands/results/SortingInfo.tsx:36
msgid "explore.sorting.info.body-one"
msgstr "Tutki hyödyntää tekoälyä ymmärtääkseen, mitä todella etsit. Toisin kuin Torin perinteinen haku, joka näyttää vain hakusanan sisältäviä tuloksia, Tutki pyrkii löytämään ilmoituksia, jotka vastaavat hakusi laajempaa tarkoitusta."

#. js-lingui-explicit-id
#: src/islands/search/FiltersModal/filters/RangeFilter.tsx:57
#: src/islands/search/FiltersModal/filters/StandardFilter.tsx:60
#: src/islands/search/FiltersModal/filters/StandardFilter.tsx:86
msgid "explore.filter.fallback"
msgstr "Suodata"

#. js-lingui-explicit-id
#: src/islands/search/FiltersModal.tsx:137
msgid "explore.searchInput.filters.back"
msgstr "Suodata"

#. js-lingui-explicit-id
#: src/islands/search/SearchBar.tsx:824
msgid "explore.searchInput.filters"
msgstr "Suodattimet"

#. js-lingui-explicit-id
#: src/islands/results/SortingInfo.tsx:22
msgid "explore.sorting.info.trigger"
msgstr "Näin haku toimii"

#. js-lingui-explicit-id
#: src/islands/header/Header.tsx:61
msgid "explore.prompt.subtitle"
msgstr "Tee torilöytöjä tekoälyn avulla"

#. js-lingui-explicit-id
#: src/islands/search/FiltersModal.tsx:638
#: src/islands/search/SearchBar.tsx:628
#: src/islands/search/SearchBar.tsx:687
msgid "explore.searchInput.filters.range.min"
msgstr "Min. {value}"

#. js-lingui-explicit-id
#: src/islands/results/FeedbackPrompt.tsx:70
msgid "explore.results.feedback.followup.button"
msgstr "Anna palautetta"

#. js-lingui-explicit-id
#: src/islands/results/ErrorState.tsx:79
msgid "explore.results.errorstate.goback.label"
msgstr "Siirry takaisin hakuun"

#. js-lingui-explicit-id
#: src/islands/results/SearchResult.tsx:143
msgid "explore.results.count.hits"
msgstr "osumaa"

#. js-lingui-explicit-id
#: src/islands/results/SortingInfo.tsx:29
msgid "explore.sorting.title"
msgstr "Näin Tutki toimii"

#. js-lingui-explicit-id
#: src/islands/suggestions/Suggestions.tsx:98
#: src/islands/suggestions/Suggestions.tsx:165
msgid "explore.suggestions.buttons.loading"
msgstr "Ehdotusta ladataan"

#. js-lingui-explicit-id
#: src/islands/suggestions/Suggestions.tsx:56
msgid "explore.suggestions.placeholder"
msgstr "Ladataan..."

#. js-lingui-explicit-id
#: src/islands/search/FiltersModal/filters/RangeFilter.tsx:111
msgid "explore.searchInput.filters.range.max.label"
msgstr "Enimmäisarvo"

#. js-lingui-explicit-id
#: src/islands/search/FiltersModal/filters/RangeFilter.tsx:107
msgid "explore.searchInput.filters.range.min.label"
msgstr "Vähimmäisarvo"

#. js-lingui-explicit-id
#: src/islands/results/FeedbackPrompt.tsx:102
msgid "explore.results.feedback.negative.label"
msgstr "Negatiivinen palaute"

#. js-lingui-explicit-id
#: src/islands/search/FiltersModal.tsx:707
msgid "explore.searchInput.filters.empty"
msgstr "Suodattimia ei ole saatavilla"

#. js-lingui-explicit-id
#: src/islands/results/ZeroResults.tsx:30
msgid "explore.results.zero-results.alt-text"
msgstr "Ei hakutuloksia"

#. js-lingui-explicit-id
#: src/islands/results/ZeroResults.tsx:36
msgid "explore.results.zero-results.heading"
msgstr "Ei hakutuloksia"

#. js-lingui-explicit-id
#: src/islands/results/ErrorState.tsx:37
msgid "explore.results.errorstate.client.heading"
msgstr "Voi ei!"

#. js-lingui-explicit-id
#: src/islands/results/FeedbackPrompt.tsx:92
msgid "explore.results.feedback.positive.label"
msgstr "Positiivinen palaute"

#. js-lingui-explicit-id
#: src/islands/search/FiltersModal/filters/RangeFilter.tsx:60
msgid "explore.filter.price.label"
msgstr "Hintaluokka"

#. js-lingui-explicit-id
#: src/server/server.ts:171
msgid "page.description"
msgstr "Tori-sivu semanttisen Tutki-haun mahdollistamiseksi"

#. js-lingui-explicit-id
#: src/islands/search/SearchBar.tsx:742
#: src/islands/search/SearchBar.tsx:791
msgid "explore.searchInput.ariaLabel"
msgstr "Hae"

#. js-lingui-explicit-id
#: src/islands/results/SortingInfo.tsx:69
msgid "explore.sorting.info.body-try-it-two-rest"
msgstr "Kokeile: Kirjoita hakukenttään \"Asu toimiston kesäjuhliin\", ja Tutki ehdottaa sinulle tilaisuuteen sopivia vaatteita."

#. js-lingui-explicit-id
#: src/islands/results/SortingInfo.tsx:33
msgid "explore.sorting.info.title-one"
msgstr "Tarkoitukseen perustuvia hakutuloksia"

#. js-lingui-explicit-id
#: src/islands/search/SearchBar.tsx:855
msgid "explore.searchInput.calloutText"
msgstr "Hae lauseella"

#. js-lingui-explicit-id
#: src/components/Ad/AdLocation.tsx:20
msgid "search.ad.bap.sold"
msgstr "Myyty"

#. js-lingui-explicit-id
#: src/islands/results/ErrorState.tsx:41
msgid "explore.results.errorstate.client.message"
msgstr "Jotain meni pieleen, eikä ilmoituksia ei voitu näyttää. Yritä uudelleen."

#. js-lingui-explicit-id
#: src/islands/results/ErrorState.tsx:22
msgid "explore.results.errorstate.server.heading"
msgstr "Pahoittelut!"

#. js-lingui-explicit-id
#: src/islands/results/FeedbackPrompt.tsx:26
msgid "explore.results.feedback.followup.negative"
msgstr "Kiitos! Haluatko kertoa tarkemmin, mistä et pitänyt?"

#. js-lingui-explicit-id
#: src/islands/results/FeedbackPrompt.tsx:21
msgid "explore.results.feedback.followup.positive"
msgstr "Kiitos! Haluatko kertoa tarkemmin, mistä pidit?"

#. js-lingui-explicit-id
#: src/islands/search/FiltersModal/filters/RangeForm.tsx:98
msgid "explore.filter.range.invalid"
msgstr "Enimmäisarvo ei voi olla pienempi kuin vähimmäisarvo."

#. js-lingui-explicit-id
#: src/islands/search/SearchBar.tsx:795
msgid "explore.searchInput.helpText"
msgstr "Vinkki! Käytä kuvailevia lauseita"

#. js-lingui-explicit-id
#: src/islands/results/ErrorState.tsx:136
#: src/islands/results/ErrorState.tsx:142
msgid "explore.results.errorstate.retry.label"
msgstr "Yritä uudelleen"

#. js-lingui-explicit-id
#: src/islands/results/SortingInfo.tsx:45
#: src/islands/results/SortingInfo.tsx:67
msgid "explore.sorting.info.try-it"
msgstr "Kokeile:"

#. js-lingui-explicit-id
#: src/islands/suggestions/Suggestions.tsx:131
msgid "explore.suggestions.title.discover"
msgstr "Kokeile hakusanaa"

#. js-lingui-explicit-id
#: src/islands/results/ZeroResults.tsx:43
msgid "explore.results.zero-results.message"
msgstr "Kokeile kuvailla etsimääsi toisin sanoin tai suodata hakuasi eri tavalla."

#. js-lingui-explicit-id
#: src/components/Ad/AdImageOptions.tsx:15
msgid "search.ad.fallback-image-alt"
msgstr "Kaksi vuorta ja pilvi"

#. js-lingui-explicit-id
#: src/islands/results/SortingInfo.tsx:47
msgid "explore.sorting.info.body-try-it-one-rest"
msgstr "Kirjoita hakukenttään ”Retro keittiön sisustus”, ja Tutki tarjoaa sinulle aiheeseen liittyviä ilmoituksia, kuten vintageastioita, valaisimia ja koriste-esineitä."

#. js-lingui-explicit-id
#: src/islands/suggestions/Suggestions.tsx:82
#: src/islands/suggestions/Suggestions.tsx:149
msgid "explore.suggestions.title.error"
msgstr "Ehdotuksia ei voitu ladata. Yritä uudelleen."

#. js-lingui-explicit-id
#: src/islands/search/FiltersModal.tsx:647
#: src/islands/search/SearchBar.tsx:634
#: src/islands/search/SearchBar.tsx:689
msgid "explore.searchInput.filters.range.max"
msgstr "Max. {value}"

#. js-lingui-explicit-id
#: src/islands/search/FiltersModal.tsx:878
msgid "explore.searchInput.filters.use"
msgstr "Käytä"

#. js-lingui-explicit-id
#: src/islands/results/ErrorState.tsx:110
#: src/islands/results/ErrorState.tsx:116
msgid "explore.results.errorstate.help.center.label"
msgstr "Tutustu asiakastukeen"

#. js-lingui-explicit-id
#: src/islands/results/ErrorState.tsx:56
msgid "explore.results.errorstate.network.message"
msgstr "Palvelimeen ei saada yhteyttä. Tarkista verkkoyhteytesi ja yritä uudelleen."

#. js-lingui-explicit-id
#: src/islands/search/SearchBar.tsx:787
msgid "explore.searchInput.placeholder"
msgstr "Mitä etsit?"

#. js-lingui-explicit-id
#: src/islands/results/FeedbackPrompt.tsx:83
msgid "explore.results.feedback.prompt"
msgstr "Mitä mieltä olet Tutki-ominaisuudesta?"

